import React, { type ReactElement, useEffect } from 'react'
import { useSnapshot } from 'valtio'
import Select from 'react-select'
import { creditCardListProxy } from '../../../../../../../../shared/proxies/creditCardListProxy'
import { rpOccurrenceEditProxy } from './rpOccurrenceEditProxy'
import { buildCreditCardOption, handleCreditCardChange, loadCreditCardOptions } from './utils'
import { AddCardButton } from './AddCardButton'

export function RpOccurrenceCreditCardDropDown (): ReactElement {
  const { customerCard, customer } = useSnapshot(rpOccurrenceEditProxy)
  const { formattedCards } = useSnapshot(creditCardListProxy)

  useEffect(() => {
    void loadCreditCardOptions()
  }, [customer?.id, customerCard])

  return (
    <div className="grid grid-cols-1 my-4">
      <div className="flex flex-col w-full">
        <label>Payment Method</label>
        <div className="flex flex-row justify-between">
          <Select
            key={customerCard?.id}
            className="flex-grow  border border-wpy-gray rounded-md"
            options={formattedCards}
            onChange={handleCreditCardChange}
            placeholder="Select Credit Card"
            isClearable
            styles={{
              control: (provided) => ({
                ...provided,
                border: 0,
                height: '100%'
              })
            }}
            tabSelectsValue
            value={customerCard ? buildCreditCardOption(customerCard) : null}
          />

        </div>
        <div className="mt-4">
          <AddCardButton text="Add New Card" />
        </div>
      </div>
    </div>
  )
}
